<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="row align-items-center mb-4">
        <div class="col-lg-4 col-sm-8">
          <div class="nav-wrapper position-relative end-0">
            <ul class="nav nav-pills nav-fill p-1" role="tablist">
              <li v-bind:key="category" class="nav-item">
                <a @click="filter('all')"
                  class="nav-link mb-0 px-0 py-1 active active"
                  data-bs-toggle="tab"
                  role="tab"
                  aria-selected="true"
                  >All</a
                >
              </li>
              <li class="nav-item">
                <a @click="filter('users')"
                  class="nav-link mb-0 px-0 py-1 active active"
                  data-bs-toggle="tab"
                  role="tab"
                  aria-selected="false"
                  >Users</a
                >
              </li>
              <li class="nav-item">
                <a @click="filter('managers')"
                  class="nav-link mb-0 px-0 py-1"
                  data-bs-toggle="tab"
                  role="tab"
                  aria-selected="false"
                  >Managers</a
                >
              </li>
              <li class="nav-item">
                <a @click="filter('gmail')"
                  class="nav-link mb-0 px-0 py-1"
                  data-bs-toggle="tab"
                  role="tab"
                  aria-selected="false"
                  >Gmail</a
                >
              </li>
              <li class="nav-item">
                <a @click="filter('outlook')"
                  class="nav-link mb-0 px-0 py-1"
                  data-bs-toggle="tab"
                  role="tab"
                  aria-selected="false"
                  >Outlook</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-if="!loading">
        <div class="row mb-4">
          <div v-show="tutorials.length !== 0" v-for="tutorial in tutorials" v-bind:key="tutorial" class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-4">
            <div class="card">
              <iframe style="border-radius: 1rem 1rem 0 0;" :src="tutorial.url.replace('watch?v=', 'embed/')" allowfullscreen></iframe>
              <div class="card-body" style="padding: 15px;">
                <div class="mb-2">
                  <span v-for="tag in tutorial.categories" v-bind:key="tag" style="padding: 1px 10px;
                    background-color: #cb0fc9;
                    color: white;
                    font-weight: bold;
                    font-size: 8px;
                    border-radius: 20px; margin-right: 5px;">{{ tag.name }}</span>
                </div>
                <h5> {{ tutorial.title }} </h5>
                <p> {{ tutorial.description }} </p>
              </div>
            </div>
          </div>
        </div>
        <div v-show="tutorials.length === 0" style="display: grid; justify-items: center;">
          <img style="width: 50%;" src="../assets/img/Webinar-pana.png" />
          <p class="text-2xl text-center sm:text-4xl font-bold text-darkblue-500 mb-2">
            Ups!... no results found
          </p>
          <p class="text-xl text-gray-700">Please try another search</p>
        </div>
      </div>

      <div v-else style="justify-content: center; padding: 15px; display: flex; align-items: center;">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      </div>
    </div>
    
    
  </div>
</template>

<script>
import setTooltip from "@/assets/js/tooltip.js";
import setNavPills from "@/assets/js/nav-pills.js";
import HTFetch from "../llamadas/HTFetch"

export default {
  name: "Tutorials",
  components: {
  },
  mounted() {
    setTooltip();
    setNavPills();

    this.loading = true
    this.llamada.tutorials(this.tutorialsRsp.bind(this))

    if (this.$gtm.enabled()) {
      window.dataLayer?.push({
        event: "tutorials",
        user_id: localStorage.userId
      });
    }
  },

  data() {
      return {
        llamada: new HTFetch(),
        tutorials: [],
        tutorialsAux: [],
        loading: false
      }
  },

  methods: {
    tutorialsRsp(rsp) {
      this.tutorials = rsp.data.response
      this.tutorialsAux = this.tutorials
      this.loading = false
    },

    filter(string) {
      if (string === 'all') {
        this.tutorials = this.tutorialsAux
      } else {

        this.tutorials = this.tutorialsAux.filter(obj => {

          for (let i = 0; i < obj.categories.length; i++) {
            let tag = obj.categories[i]
            if (tag.name === string) {
              return obj
            }
          }
          
        });
      }

    }
  }
};
</script>
<style scoped>
  a {
    cursor: pointer;
  }

  video {
    border-radius: 1rem 1rem 0 0;
  }
</style>